import { render, staticRenderFns } from "./StaffEditModal.vue?vue&type=template&id=380e40dc&"
import script from "./StaffEditModal.vue?vue&type=script&lang=js&"
export * from "./StaffEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports